/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEventStateRequestDto,
  EventStateResponseDto,
  ListEventStateImportRequestsResponseDto,
  ListEventStatesResponseDto,
  UpdateEventStateRequestDto,
} from '../models/index';
import {
    CreateEventStateRequestDtoFromJSON,
    CreateEventStateRequestDtoToJSON,
    EventStateResponseDtoFromJSON,
    EventStateResponseDtoToJSON,
    ListEventStateImportRequestsResponseDtoFromJSON,
    ListEventStateImportRequestsResponseDtoToJSON,
    ListEventStatesResponseDtoFromJSON,
    ListEventStatesResponseDtoToJSON,
    UpdateEventStateRequestDtoFromJSON,
    UpdateEventStateRequestDtoToJSON,
} from '../models/index';

export interface EventStateControllerBatchImportRequest {
    file: Blob;
}

export interface EventStateControllerCreateRequest {
    createEventStateRequestDto: CreateEventStateRequestDto;
}

export interface EventStateControllerDeleteRequest {
    id: string;
}

export interface EventStateControllerFindAllRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface EventStateControllerFindByIdRequest {
    id: string;
}

export interface EventStateControllerFindImportRequestsRequest {
    limit: number;
    page: number;
}

export interface EventStateControllerUpdateRequest {
    id: string;
    updateEventStateRequestDto: UpdateEventStateRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseEventStatesApi extends runtime.BaseAPI {

    /**
     */
    async eventStateControllerBatchImportRaw(requestParameters: EventStateControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling eventStateControllerBatchImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/api/v1/event-states/batch-import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async eventStateControllerBatchImport(requestParameters: EventStateControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.eventStateControllerBatchImportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async eventStateControllerCreateRaw(requestParameters: EventStateControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventStateResponseDto>> {
        if (requestParameters['createEventStateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createEventStateRequestDto',
                'Required parameter "createEventStateRequestDto" was null or undefined when calling eventStateControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEventStateRequestDtoToJSON(requestParameters['createEventStateRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventStateResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async eventStateControllerCreate(requestParameters: EventStateControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventStateResponseDto> {
        const response = await this.eventStateControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async eventStateControllerDeleteRaw(requestParameters: EventStateControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eventStateControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async eventStateControllerDelete(requestParameters: EventStateControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.eventStateControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async eventStateControllerFindAllRaw(requestParameters: EventStateControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEventStatesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling eventStateControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling eventStateControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListEventStatesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async eventStateControllerFindAll(requestParameters: EventStateControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEventStatesResponseDto> {
        const response = await this.eventStateControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async eventStateControllerFindByIdRaw(requestParameters: EventStateControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventStateResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eventStateControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventStateResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async eventStateControllerFindById(requestParameters: EventStateControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventStateResponseDto> {
        const response = await this.eventStateControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async eventStateControllerFindImportRequestsRaw(requestParameters: EventStateControllerFindImportRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEventStateImportRequestsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling eventStateControllerFindImportRequests().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling eventStateControllerFindImportRequests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states/import-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListEventStateImportRequestsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async eventStateControllerFindImportRequests(requestParameters: EventStateControllerFindImportRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEventStateImportRequestsResponseDto> {
        const response = await this.eventStateControllerFindImportRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async eventStateControllerUpdateRaw(requestParameters: EventStateControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventStateResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eventStateControllerUpdate().'
            );
        }

        if (requestParameters['updateEventStateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateEventStateRequestDto',
                'Required parameter "updateEventStateRequestDto" was null or undefined when calling eventStateControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/event-states/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEventStateRequestDtoToJSON(requestParameters['updateEventStateRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventStateResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async eventStateControllerUpdate(requestParameters: EventStateControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventStateResponseDto> {
        const response = await this.eventStateControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
